const ContainerUserRating = ({ children }) => {
  return (
    <div
      className="bg-[url('assets/images/icons/rating-icons/bg-rating.png')] bg-center bg-no-repeat bg-fixed bg-cover min-h-screen flex justify-center items-center"
      id="container-user-rating"
    >
      <div className="p-3">
        <div className="bg-white  rounded-lg max-w-[450px] m-auto flex flex-col items-center py-6 px-4">
          {children}
        </div>
      </div>
    </div>
  );
};

export default ContainerUserRating;
